
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"storeCurrency"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StoreCurrency"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thousandsSeparator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"decimalMark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbolFirst"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":109}};
    doc.loc.source = {"body":"fragment storeCurrency on StoreCurrency {\n  code\n  symbol\n  thousandsSeparator\n  decimalMark\n  symbolFirst\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
